import {SET_GIA_REPORT_PARAMS} from "../giaReducer";

const initialState = {}

export const reportParamsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GIA_REPORT_PARAMS:
            return action.payload;
        default:
            return state;
    }
};
